import { type VariableValue } from "@doitintl/cmp-models/src/CloudFlowVariables";
import { TableCell, Typography } from "@mui/material";

import { globalText } from "../../../assets/texts";
import { CellsWrapper } from "../../../Components/FilterTable/Toolbar/CellsWrapper";
import { ThreeDotsMenu, type ThreeDotsMenuOption } from "../../../Components/ThreeDotsMenu/ThreeDotsMenu";

type Props = {
  item: VariableValue;
  onEdit?: (item: VariableValue) => void;
  onDelete: (item: VariableValue) => void;
};

const GlobalVariableRow = ({ item, onEdit, onDelete }: Props) => {
  const options: ThreeDotsMenuOption[] = [
    {
      label: globalText.EDIT,
      action: () => onEdit?.(item),
      key: globalText.EDIT,
    },
    {
      label: <Typography color="error">{globalText.DELETE}</Typography>,
      action: () => {
        onDelete(item);
      },
      key: globalText.DELETE,
    },
  ];

  return (
    <CellsWrapper>
      <TableCell>
        <Typography variant="body2">{item.name}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">{String(item.value)}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">{item.owner}</Typography>
      </TableCell>
      <TableCell align="right">
        <ThreeDotsMenu options={options} size="small" closeAfterSelect data-cy="global-variable-actions" />
      </TableCell>
    </CellsWrapper>
  );
};

export default GlobalVariableRow;
